export const passwordGenerator = (len) => {
  const length = len || (12);
  const string = 'abcdefghijklmnopqrstuvwxyz';
  const numeric = '0123456789';
  const punctuation = '!@#$%^&*()_+~`|}{[]\\:;?><,./-=';
  let password = '';
  let character = '';
  let entity1;
  let entity2;
  let entity3;
  let hold;
  while (password.length < length) {
    entity1 = Math.ceil(string.length * Math.random() * Math.random());
    entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
    entity3 = Math.ceil(punctuation.length * Math.random() * Math.random());
    hold = string.charAt(entity1);
    hold = (password.length % 2 === 0) ? (hold.toUpperCase()) : (hold);
    character += hold;
    character += numeric.charAt(entity2);
    character += punctuation.charAt(entity3);
    password = character;
  }
  password = password.split('').sort(() => 0.5 - Math.random()).join('');
  return password.substr(0, len);
};
